'use strict';

var _ = require('lodash');
var DaysOfWeekHelper = function DaysOfWeekHelper($filter, momentService) {
  var rmMomentFormat = $filter('rmMomentFormat');

  /**
   *
   * @param {MomentFactory} date
   * @param {string} dayName
   * @returns {MomentFactory}
   */
  function dayOfWeekAfter(date, dayName) {
    var day = date.setDay(dayName);
    return date.isAfter(day) ? day.add(1, 'weeks') : day;
  }

  /**
   *
   * @param {string} year
   * @param {string} firstDayOfDow
   * @returns {MomentFactory}
   */
  function getFirstDayOfDow(year, firstDayOfDow) {
    var moment = momentService.of(year, momentService.FIELD.DEPARTURE_DATE, momentService.FORMAT.YEAR).setDay(firstDayOfDow);
    if (moment.isoWeekOfYear() != 1) {
      return moment.add(1, 'weeks');
    }
    return moment;
  }

  /**
   *
   * @param {MomentFactory} inDate
   * @param {MomentFactory} rangeStart
   * @param {MomentFactory} rangeEnd
   * @param dowGroupDefinition
   * @returns {Array}
   */
  function daysMatchingDowGroup(inDate, rangeStart, rangeEnd, dowGroupDefinition) {
    var inDatePlusWeek = inDate.add(6, 'days');
    var weekStart = inDate.isBefore(rangeStart) ? rangeStart : inDate;
    var weekEnd = inDatePlusWeek.isAfter(rangeEnd) ? rangeEnd : inDatePlusWeek;
    if (weekEnd.diff(weekStart, 'days') === 7) {
      return dowGroupDefinition;
    }
    var daysMatching = [];
    var date = weekStart;
    while (!date.isAfter(weekEnd)) {
      daysMatching.push(rmMomentFormat(date, 'DAY_OF_WEEK'));
      date = date.add(1, 'day');
    }
    return _.intersection(daysMatching, dowGroupDefinition);
  }
  return {
    dayOfWeekAfter: dayOfWeekAfter,
    getFirstDayOfDow: getFirstDayOfDow,
    daysMatchingDowGroup: daysMatchingDowGroup
  };
};
DaysOfWeekHelper.$inject = ['$filter', 'MomentService'];
module.exports = DaysOfWeekHelper;